<template>
  <div align="left">
    <b-tabs vertical pills>
      <b-tab title="Bases" active><bases/></b-tab>
      <b-tab title="Conversions"><conversions/></b-tab>
      <b-tab title="Ranges"><ranges/></b-tab>
      <b-tab title="Abbreviations"><abbreviations/></b-tab>
    </b-tabs>
  </div>
</template>

<script>
import bases from '@/components/bases'
import conversions from '@/components/conversions'
import ranges from '@/components/ranges'
import abbreviations from '@/components/abbreviations'

export default {
  name: 'integers',
  components: {
    bases,
    conversions,
    ranges,
    abbreviations
  }
}
</script>


// WEBPACK FOOTER //
// src/components/integers.vue